{
  "back": "戻る",
  "form": "フォーム",
  "purposeTitle": "今回の立ち寄りの目的は何ですか？",
  "appointmentInfoTitle": "予約情報",
  "appointmentInfoHint": "予約がある場合は、必ずこの項目を入力してください。",
  "checkInDetailsTitle": "チェックインの詳細",
  "checkInDetailsHint": "訪問に関する追加情報。",
  "driverPhoneLabel": "ドライバーの電話番号",
  "activateWhatsAppTitle": "WhatsApp メッセージを有効にする",
  "activateWhatsAppBody": "倉庫とチャットするには、最初の WhatsApp メッセージが届いたら「OK」と返信してください。",
  "whatsappDelayBanner": "最初の WhatsApp メッセージが届くまで最大 1 分ほどかかる場合があります。",
  "notesLabel": "メモ",
  "notesPlaceholder": "施設への特別な指示やメモはありますか？",
  "verifyAndCheckIn": "確認してチェックイン",
  "completeCheckIn": "チェックインを完了",
  "visitGroupInbound": "入荷",
  "visitGroupOutbound": "出荷",
  "visitGroupBoth": "入荷・出荷",
  "visitUnloadTruck": "トラックの荷降ろし",
  "visitDropTrailer": "トレーラーまたはコンテナの切り離し",
  "visitLoadTruck": "トラックへの積み込み",
  "visitHookTrailer": "トレーラーまたはコンテナの連結",
  "visitUnloadLoad": "トラックの荷降ろしと積み込み",
  "visitDropHook": "トレーラーまたはコンテナの切り離しと連結",
  "containerTrailer": "トレーラー",
  "containerContainer": "コンテナ",
  "containerOversized": "特大",
  "containerOther": "その他",
  "defaultReferenceName": "発注番号（PO Number）",
  "identifierSuffix": "{reference} または確認番号",
  "licenseOrDotRequired": "ナンバープレートまたは DOT 番号を入力してください",
  "appointmentNotFound": "予約が見つかりませんでした",
  "referenceNotFound": "一致する予約が見つかりません。参照番号は大文字と小文字が区別されます。",
  "referenceCaseSensitiveHint": "参照番号は大文字と小文字が区別されます",
  "messaging": {
    "whatsappFailedTitle": "WhatsApp メッセージを送信できません",
    "smsFailedTitle": "SMS メッセージを送信できません",
    "whatsappFailedBody": "{displayPhone} にメッセージを送信できませんでした。<br /><br /> 以前に配信を停止した場合は、<a href='{waUrl}' target='_blank' rel=\"noopener noreferrer\">{senderPhone}</a> に START と送信すると、この倉庫からのメッセージの受信が再開されます。",
    "smsFailedBody": "{displayPhone} にメッセージを送信できませんでした。<br /><br /> 以前に配信を停止した場合は、<a href='{smsUrl}'>{senderPhone}</a> に START と送信すると、この倉庫からの SMS メッセージの受信が再開されます。",
    "fallbackPhone": "入力された電話番号"
  }
}
